import Tooltip from '@mui/material/Tooltip';
import additionSymbol from '../../../../Assets/Icons/additionSymbol.svg';
import trackingService, { TrackingEvent } from '../../../../Services/Tracking/TrackingService';
import styles from './IndicatorsManagementButton.module.scss';

interface IIndicatorsManagementButtonProps {
    tooltipText?: string;
    handleClick: () => void;
    disabled?: boolean;
    track: TrackingEvent;
}

const IndicatorsManagementButton: React.FC<IIndicatorsManagementButtonProps> = (props: IIndicatorsManagementButtonProps) => {
    const handleClick = () => {
        props.handleClick();
        trackingService.track(props.track);
    };

    return (
        <Tooltip title={props.tooltipText} placement="right-start">
            <button type="button" onClick={handleClick} disabled={props.disabled} className={styles.indicators_management_button}>
                <img src={additionSymbol} alt="#" />
            </button>
        </Tooltip>
    );
};

export default IndicatorsManagementButton;
